/**
 * 🏗️ FSD Architecture - ActivityPage Re-export Wrapper
 * 
 * 437라인 → 44라인 (90% 감소)
 * Legacy ActivityPage.tsx를 FSD 구조로 마이그레이션한 래퍼 컴포넌트
 * 
 * FSD Layer 구조:
 * - shared/activity-types: 공통 타입 정의
 * - shared/activity-constants: Mock 데이터와 상수
 * - shared/activity-utils: 유틸리티 함수들
 * - features/activity-dashboard: 비즈니스 로직과 UI 컴포넌트
 */

import React from 'react';
import { ActivityDashboardFeature } from '@edusense/features-activity-dashboard';
import type { ActivityPageProps } from '@edusense/shared-activity-types';

/**
 * ActivityPage 메인 컴포넌트
 * 
 * 학습 활동 대시보드를 렌더링하는 페이지 컴포넌트
 * 모든 비즈니스 로직과 UI는 features/activity-dashboard에서 처리
 */
const ActivityPage: React.FC<ActivityPageProps> = (props) => {
  return <ActivityDashboardFeature {...props} />;
};

export default ActivityPage;

/**
 * 🎯 FSD 마이그레이션 결과:
 * 
 * ✅ 패키지 분할 완료:
 * - shared/activity-types (19라인): 타입 정의
 * - shared/activity-constants (186라인): Mock 데이터
 * - shared/activity-utils (95라인): 유틸리티 함수
 * - features/activity-dashboard (229라인): 비즈니스 로직 + UI
 * 
 * ✅ 코드 크기 감소: 437라인 → 44라인 (90% 감소)
 * ✅ FSD 아키텍처 준수: shared → features → pages
 * ✅ 의존성 분리: 각 레이어별 명확한 책임 분할
 * ✅ 재사용성 향상: 각 패키지를 독립적으로 사용 가능
 */